<template>
  <div>
    <CatBanner :imageList="this.config.banner_top.imageList"></CatBanner>
    <CatIntroduction></CatIntroduction>
    <CatBenefits></CatBenefits>
    <CatDownload></CatDownload>

    <CatBannerApp></CatBannerApp>

    <CatContentView></CatContentView>
    <CatContent></CatContent>
    <CatLogo></CatLogo>

    <CatBanner3></CatBanner3>
  </div>
</template>

<script>
import CatBanner from "@/yintai/view/content/cat/CatBanner.vue";
import CatLogo from "@/yintai/view/content/cat/CatLogo.vue";
import CatBenefits from "@/yintai/view/content/cat/CatBenefits.vue";

import CatBannerApp from "@/yintai/view/content/cat/CatBannerApp.vue";
import CatIntroduction from "@/yintai/view/content/cat/CatIntroduction.vue";

import CatContent from "@/yintai/view/content/cat/CatContent.vue";
import CatContentView from "@/yintai/view/content/cat/CatContentView.vue";
import CatDownload from "@/yintai/view/content/cat/CatDownload.vue";
import CatBanner3 from "@/yintai/view/content/cat/CatBanner3.vue";
import { fetchConfig } from "@/yintai/api/config";

export default {
  name: "cat",
  components: {
    CatBanner,
    CatIntroduction,
    CatBenefits,
    CatLogo,
    CatBannerApp,
    CatContent,
    CatContentView,
    CatDownload,
    CatBanner3,
  },
  metaInfo() {
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      meta: [{name: "keywords" ,content:"喵街,喵街app,喵街逛街神器,银泰百货,银泰商业,智慧新零售"},{name: "description" ,content:"喵街App是由银泰商业打造的新一代消费者逛街神器，通过向商场、商圈和商户提供互联网商业解决方案。基于大数据，为用户匹配最适合该用户的商场及品牌信息，提升商圈商业价值。"}],
      title: "喵街__线上线下高度融合的数字商场_银泰百货官网"
      // all titles will be injected into this template
      // titleTemplate: "%s | My Awesome Webapp",
    };
  },
  data() {
    return {
      config: {
        banner_top: {
          imageList: [],
        },
      },
    };
  },
  async mounted() {
    const response = await fetchConfig({ id: 10 });
    this.config = response.data.data.item.config;
  },
  methods: {},
};
</script>
